// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SnapcodesForm_wrapper__3NfDt","addButton":"SnapcodesForm_addButton__H7qk0"};